import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submit, getFormValues, isValid } from 'redux-form';
import { BookTour } from '../../actions/booking';
import { SetPassengerDetails, SetBooking, SetTripPassengers } from '../../actions/currentBooking';
import { store } from '../../index';
import { history } from '../../components/app';
import _filter from 'lodash/filter';


class BasketBooking extends PureComponent{

  constructor(){
    super();
    this.state = {
      basketPaxDetails:{},
      termsCheck:false
    }
    this.onBookTour = this.onBookTour.bind(this);
    this.handleTermsChange = this.handleTermsChange.bind(this);
  }


  componentDidCatch(error, info) {
    this.props.history.push('/');
  }

  onBookTour(){

    const {
      BookTour,
      currency:{ iso_currency_code },
      basketType,
      SetPassengerDetails,
      basketPaxValues,
      SetBooking,
      booking,
      product,
      currentTrip,
      paxNumber
    } = this.props;


  if(!booking){

      //Set booking preloader
      SetBooking(true)

      // Save pax in state if currentBooking is reset
      this.setState({basketPaxDetails:basketPaxValues}, () => {
        SetPassengerDetails(this.state.basketPaxDetails);


        //Set passenger reservation payload for hoho
        if(product.header.type === "hoho"){
          const cityPayload = _filter(product.map, ['start_city_id', currentTrip.city_id]);
          this.props.SetTripPassengers(paxNumber, cityPayload,  currentTrip.departure_date);
        }

        BookTour(iso_currency_code, store.getState().currentBooking, this.state.termsCheck).then((data)=>{
  
          if(basketType === ""){
            history.push('/paymentdetails/' + data.group_booking_id );
          }else{
            //open paymentdetails page in new winow/tab with bookingId in the parameter
            window.parent.location.href = window.location.origin + "/paymentdetails/" + data.group_booking_id;
          }
        });

      });

    }

  }


  handleTermsChange(){
    this.setState({termsCheck: !this.state.termsCheck});
  }

  render(){
    const { basketPaxValid } = this.props;

    return (
      <div className="basket-book-box">
        <div className="row">
          <div className="column small-12 medium-6 keep-informed-text medium-offset-6">
            <label className="checkbox-container terms-checkbox">
              <span className="payment-info-text">Keep me informed about the progress of my booking. We take the protection of your <a href="https://www.busabout.com/privacy-policy" className="busabout--cta--link orange" target="_blank" rel="noopener noreferrer">personal data</a> seriously.</span>
              <input name="termcheck" type="checkbox"  defaultChecked={this.state.termsCheck} onChange={this.handleTermsChange}/>
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
        <div className="row">
         <div className="column small-12 medium-6 large-5 benefits-text">
           <p className="bold">Benefits of Booking with Busabout</p>
           <ul>
             <li>We never cancel a trip and do not operate a minimum number policy. When you book one of our trips you are absolutely guaranteed to go.</li>
             <li>Discount for groups, past passengers and multi-trip.</li>
             <li>Flexible discount and instant booking confirmation.</li>
             <li>Secure online booking and management </li>
           </ul>
         </div>

         <div className="column small-12 medium-6 large-7 text-right">
           <button
             type="submit"
             className={`mobile-width busabout--cta orange ${(basketPaxValid) ? '': 'disabled'}` }
             onClick={this.onBookTour}
             disabled={ (basketPaxValid) ? false : true}>
             Continue booking
           </button>
         </div>
       </div>
     </div>
  )
  }
}



function mapStateToProps(state){
  return{
    product:state.product,
    currentTrip:state.currentBooking.trips[0],
    paxNumber:state.currentBooking.passengers.length,
    booking:state.currentBooking.booking,
    currency:state.currency,
    basketPaxValues:getFormValues('BasketPax')(state),
    basketPaxValid: isValid('BasketPax')(state),
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    BookTour,
    submit,
    SetPassengerDetails,
    SetBooking,
    SetTripPassengers
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BasketBooking);



// WEBPACK FOOTER //
// ./src/components/basket/basketbooking.js